import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { Container } from 'react-bootstrap';
import MetaData from '../MetaData';
import SectionHeading from '../common/SectionHeading';
import { clearErrors, myOrders } from '../../redux/actions/orderActions';
import { MdOutlineLaunch } from 'react-icons/md';
import Table from 'react-bootstrap/Table';
import { useNavigate, Link } from 'react-router-dom';

const MyOrders = () => {
    const dispatch = useDispatch();
    const { error, orders, loading } = useSelector((state) => state.myOrders);
    const { user } = useSelector((state) => state.user);
    const navigate = useNavigate();

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        dispatch(myOrders());
    }, [error]);

    // const columns = [
    //     {
    //         field: 'id',
    //         headerName: 'OrderID',
    //         minWidth: 300,
    //         flex: 1,
    //     },
    //     {
    //         field: 'status',
    //         headerName: 'Status',
    //         minWidth: 150,
    //         flex: 0.5,
    //         cellClassName: (params) => {
    //             return params.getValue(params.id, 'status') === 'Delivered'
    //                 ? 'text-success'
    //                 : 'text-danger';
    //         },
    //     },
    //     {
    //         field: 'itemQty',
    //         headerName: 'Items Qty',
    //         type: 'number',
    //         minWidth: 150,
    //         flex: 0.3,
    //     },
    //     {
    //         field: 'amount',
    //         headerName: 'Amount',
    //         type: 'number',
    //         minWidth: 270,
    //         flex: 0.5,
    //     },
    //     {
    //         field: 'actions',
    //         headerName: 'Actions',
    //         type: 'number',
    //         minWidth: 150,
    //         flex: 0.3,
    //         sortable: false,
    //         renderCell: (params) => {
    //             return (
    //                 <Link to={`/order/${params.getValue}`}>
    //                     <MdOutlineLaunch />
    //                 </Link>
    //             );
    //         },
    //     },
    // ];

    // const rows = [];

    // useEffect(() => {
    //     orders &&
    //         orders.length > 0 &&
    //         orders.map((item, i) => {
    //             rows.push({
    //                 itemsQty: item.orderItems.length,
    //                 id: item._id,
    //                 status: item.orderStatus,
    //                 amount: item.totalPrice,
    //             });
    //         });
    // }, [orders]);

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`${user.name}'s Orders`} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'My Orders'} />
                    {/* <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        // disableSelectionOnClick
                        // className='myOrdersTable'
                        // autoHeight
                    /> */}
                    <div className='scrollableTable'>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>OrderID</th>
                                    <th>Status</th>
                                    <th>Items Qty</th>
                                    <th>Amount</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders &&
                                    orders.length > 0 &&
                                    orders.map((item, i) => (
                                        <tr key={i}>
                                            <td>{item._id}</td>
                                            <td
                                                className={
                                                    item.orderStatus.toUpperCase() === 'DELIVERED'
                                                        ? 'text-green'
                                                        : item.orderStatus.toUpperCase() ===
                                                          'CANCELLED'
                                                        ? 'text-danger'
                                                        : 'text-warning'
                                                }
                                            >
                                                {item.orderStatus}
                                            </td>
                                            <td>{item.orderItems.length}</td>
                                            <td>{item.totalPrice}</td>
                                            <td>
                                                <Link to={`/order/${item._id}`}>
                                                    <MdOutlineLaunch />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default MyOrders;
